import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

export class LieuAppointment extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { item } = this.props;
    if (this.props.item) {
      return (
        <div
          onClick={e =>
            this.props.item.fistdispo.date_aff && this.props.onClick(e, item)
          }
          style={{
            width: "240px",
            minWidth: "240px",
            minHeight: "165px",
            height: "auto",
            borderRadius: "4px",
            backgroundColor: "#ECF6FA",
            boxShadow: "1px 0px 3px #28282859",
            display: "flex",
            flexDirection: "column",
            gap: "0",
            overflow: "hidden",
            cursor: "pointer"
          }}
        >
          <div style={{ flex: "5", padding: "2px" }}>
            <h2
              style={{
                fontSize: "15px",
                color: "#117BA2",
                textTransform: "uppercase",
                marginBottom: "6px",
                fontWeight: "bold"
              }}
            >
              {this.props.item?.nom_lieux}
            </h2>
            <hr
              style={{
                marginLeft: "15%",
                marginRight: "15%",
                color: "#117BA2",
                border: "solid",
                borderColor: "#117BA2",
                borderWidth: "1px",
                marginTop: "1px"
              }}
            />
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "bolder",
                color: "#117BA2",
                marginBottom: "2px"
              }}
            >
              {this.props.item.fistdispo?.ville}
            </h2>
            <h2
              style={{
                fontSize: "14px",
                fontWeight: "lighter",
                color: "#117BA2",
                marginTop: "0px"
              }}
            >
              {this.props.item.fistdispo?.adresse}
            </h2>
          </div>
          <div
            style={{
              flex: "2",
              backgroundColor: "#117BA2",
              padding: "2px",
              minHeight: "58px"
            }}
          >
            {this.props.item.fistdispo?.date_aff ? (
              <>
                <p
                  style={{
                    fontSize: "13px",
                    marginTop: "4px",
                    marginBottom: "2px",
                    color: "white"
                  }}
                >
                  Prochaine disponibilité
                </p>
                <p
                  style={{
                    fontSize: "13px",
                    marginTop: "4px",
                    marginBottom: "2px",
                    color: "white",
                    fontWeight: "bold"
                  }}
                >
                  {this.props.item.fistdispo.date_aff}
                </p>
              </>
            ) : (
              <p
                style={{
                  fontSize: "14px",
                  marginTop: "16px",
                  marginBottom: "2px",
                  color: "white",
                  fontWeight: "bold"
                }}
              >
                Aucune disponibilité
              </p>
            )}
          </div>
        </div>
      );
    }
  }
}

LieuAppointment.propTypes = {
  item: PropTypes.any,
  onClick: PropTypes.func
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LieuAppointment);
